'use strict';

var Types = require('./types');

var cvcRegex = /^\d{3,4}$/;
module.exports = Cvc;

function Cvc(data) {
  var types = Types(data);
  return {
    isValid: cvcIsValid
  };

  function cvcIsValid(cvc, type) {
    if (typeof cvc !== 'string') return false;
    if (!cvcRegex.test(cvc)) return false;

    if (!type) {
      return types.some(function (type) {
        return type.cvcLength === cvc.length;
      });
    }

    return types.get(type).cvcLength === cvc.length;
  }
}